export default __webpack_public_path__ + "static/media/glare_landscape_colour.7df0b838.jpg";